"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _utils = require("@package/utils");

var _storybook = require("@pikassa/storybook");

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Form = _interopRequireDefault(require("./Form"));

var _useGetShops = _interopRequireDefault(require("./hooks/useGetShops"));

var _useGetSelectedMethod = _interopRequireDefault(require("./hooks/useGetSelectedMethod"));

var _useGetSelectedAccount = _interopRequireDefault(require("./hooks/useGetSelectedAccount"));

var _useGetAccountsFromShop = _interopRequireDefault(require("./hooks/useGetAccountsFromShop"));

var _useGetPayoutMethodsFromSelectedShop = _interopRequireDefault(require("./hooks/useGetPayoutMethodsFromSelectedShop"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function HOC() {
  try {
    var handleSubmit = function handleSubmit(data) {
      dispatch((0, _functionalButton.createPayout)(data));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var shops = (0, _reactRedux.useSelector)(_functionalButton.selectShops);
    var availableShops = (0, _useGetShops["default"])(shops);
    var defaultShop = availableShops.length ? availableShops[0] : null;
    var accounts = (0, _useGetAccountsFromShop["default"])(defaultShop);
    var defaultAccount = (0, _useGetSelectedAccount["default"])(accounts);
    var availablePaymentMethods = (0, _useGetPayoutMethodsFromSelectedShop["default"])(defaultShop);
    var defaultPaymentMethod = (0, _useGetSelectedMethod["default"])(availablePaymentMethods);
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInProcess);
    (0, _hoc.useMount)(function () {
      dispatch((0, _functionalButton.getShops)({
        minAmount: 10,
        include: ['additionalSettings', 'payoutMethods', 'payoutRoutes']
      }));
    });
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });

    if (inProcess) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['spinner']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null));
    }

    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      shops: availableShops,
      onSubmit: function onSubmit(data) {
        return handleSubmit(data);
      },
      initialValues: {
        externalId: (0, _utils.uuid)(),
        shop: defaultShop,
        paymentMethod: defaultPaymentMethod,
        'amount-debit': null,
        'amount-credit': null,
        account: defaultAccount
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;